const DEFAULT_GTM_ID = "GTM-P2XHJXT";
const configuredGtmId = process.env.NEXT_PUBLIC_GTM_ID || DEFAULT_GTM_ID;

export const GTM_ID = /^GTM-[A-Z0-9]+$/.test(configuredGtmId)
  ? configuredGtmId
  : DEFAULT_GTM_ID;

export const isAnalyticsEnabled =
  process.env.enableGtm === "true" && Boolean(GTM_ID);

export const canTrackCurrentPage = () => {
  return typeof window !== "undefined" &&
    isAnalyticsEnabled &&
    window.location.hostname === process.env.GOOGLE_TRACKING_HOSTNAME;
};
